import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PATH } from '@app/constants';
import { DevelopmentPreview } from '@app/models';
import { NewCardProjectListComponent } from './new-card-project-list/new-card-project-list.component';
import { UserInfo } from '@interfaces/app';

@Component({
  selector: 'mnf-dashboard-v2-project-list',
  standalone: true,
  imports: [CommonModule, NewCardProjectListComponent],
  templateUrl: './dashboard-v2-project-list.component.html',
  styleUrl: './dashboard-v2-project-list.component.scss',
})
export class DashboardV2ProjectListComponent implements OnChanges {

  @Input() userWithBothStatus: boolean;
  @Input() developmentsAvailable: any
  user: UserInfo;

  userWithAutoGrowth: boolean;
  userWithDomiciliation: boolean;
  
  devs: DevelopmentPreview[];
  devsPath = `${PATH.ROUTE_AVAILABLE_PROJECTS_HOME}`;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['developmentsAvailable'] && this.developmentsAvailable) {
      this.devs = this.developmentsAvailable
        .map((dev: any) => ({
          ...dev,
          priority: dev.priority || dev.d?.priority || 20
        }))
        .sort((a: any, b: any) => a.priority - b.priority);
    }
  }
}
